import { Card, DatePicker, Empty, Space } from "antd";
import ListTable from "common/ListTable";
import moment from "moment";
import { getData } from "apiServices/common";
import { useCallback, useEffect, useRef, useState } from "react";

const data = [
  {
    export_id: 301,
    sales_contract: "G-Tex/Concorde-141/24",
    payment_terms: "TT",
    invoice_number: "CGL/G-TEX/147/2025",
    export_qty_pcs: 10763,
    esport_qty_ctn: 499,
    fob_pcs: "",
    total_fob: "",
    cm_pcs: 1.76,
    total_cm: 391160.55,
    ex_fac_date: "2025-03-14",
    handover_date: "2025-03-15",
    onboard_date: "2025-03-18",
    time_delay_for_forwarder: 3,
    document_submission_date: "",
    delay_for_document_submission: "",
    acceptance_date: "",
    delay_in_acceptance: "",
    payment_due_date: "2025-04-02",
    payment_received_date: "",
    realise_date: "",
    co_bl_cost: "",
    cnf_cost_export: "",
    cnf_cost_paid_export: "",
    potential_opportunity_for_savings: "",
    used_transport: "",
    cbm_information: "",
    transport_qty: "",
    optimum_trucking: "",
    optimum_cost: "",
    potential_savings_opportunity: "",
    size_of_truck: "",
    potential_opportunity_saving_trucking: "",
    bgmea_commission: "",
    ud_fee: "",
    amendment: "",
    ud_cost: "",
    transport_cost_import: "",
    transport_cost_export: "",
    exp_cost: "",
    source_tax: "",
    central_bank_found: "",
  },
];

const columns = [
  {
    title: "Sales Contract#",
    dataIndex: "sales_contract",
    key: "sales_contract",
    fixed: "left",
    children: [
      {
        title: "",
        fixed: "left",
        dataIndex: "sales_contract",
        key: "sales_contract",
      },
    ],
  },
  {
    title: "Payment Terms",
    dataIndex: "payment_terms",
    key: "payment_terms",
    fixed: "left",
    children: [
      {
        title: "",
        fixed: "left",
        dataIndex: "payment_terms",
        key: "payment_terms",
      },
    ],
  },
  {
    title: "Invoice Number",
    dataIndex: "invoice_number",
    key: "invoice_number",
    children: [
      {
        title: "",
        dataIndex: "invoice_number",
        key: "invoice_number",
      },
    ],
  },
  {
    title: "Export Quantity/Pcs",
    dataIndex: "export_qty_pcs",
    key: "export_qty_pcs",
    children: [
      {
        title: "",
        dataIndex: "export_qty_pcs",
        key: "export_qty_pcs",
      },
    ],
  },
  {
    title: "Export Quantity/Ctn",
    dataIndex: "esport_qty_ctn",
    key: "esport_qty_ctn",
    children: [
      {
        title: "",
        dataIndex: "esport_qty_ctn",
        key: "esport_qty_ctn",
      },
    ],
  },
  {
    title: "FOB/Pcs",
    dataIndex: "fob_pcs",
    key: "fob_pcs",
    children: [
      {
        title: "",
        dataIndex: "fob_pcs",
        key: "fob_pcs",
      },
    ],
  },
  {
    title: "Total FOB",
    dataIndex: "total_fob",
    key: "total_fob",
    children: [
      {
        title: "",
        dataIndex: "total_fob",
        key: "total_fob",
      },
    ],
  },
  {
    title: "CM/PCS",
    dataIndex: "cm_pcs",
    key: "cm_pcs",
    children: [
      {
        title: "",
        dataIndex: "cm_pcs",
        key: "cm_pcs",
      },
    ],
  },
  {
    title: "TOTAL CM",
    dataIndex: "total_cm",
    key: "total_cm",
    children: [
      {
        title: "",
        dataIndex: "total_cm",
        key: "total_cm",
      },
    ],
  },
  {
    title: "Ex-Fac Date",
    dataIndex: "ex_fac_date",
    key: "ex_fac_date",
    children: [
      {
        title: "",
        dataIndex: "ex_fac_date",
        key: "ex_fac_date",
      },
    ],
  },
  {
    title: "Handover Date",
    dataIndex: "handover_date",
    key: "handover_date",
    children: [
      {
        title: "",
        dataIndex: "handover_date",
        key: "handover_date",
      },
    ],
  },
  {
    title: "Onboard Date",
    dataIndex: "onboard_date",
    key: "onboard_date",
    children: [
      {
        title: "",
        dataIndex: "onboard_date",
        key: "onboard_date",
      },
    ],
  },
  {
    title: "Time Delay by Forwarder",
    dataIndex: "time_delay_for_forwarder",
    key: "time_delay_for_forwarder",
    children: [
      {
        title: "",
        dataIndex: "time_delay_for_forwarder",
        key: "time_delay_for_forwarder",
      },
    ],
  },
  {
    title: "Document Submission Date",
    dataIndex: "document_submission_date",
    key: "document_submission_date",
    children: [
      {
        title: "",
        dataIndex: "document_submission_date",
        key: "document_submission_date",
      },
    ],
  },
  {
    title: "Delay in Document Submission",
    dataIndex: "delay_for_document_submission",
    key: "delay_for_document_submission",
    children: [
      {
        title: "",
        dataIndex: "delay_for_document_submission",
        key: "delay_for_document_submission",
      },
    ],
  },
  {
    title: "Acceptance Date",
    dataIndex: "acceptance_date",
    key: "acceptance_date",
    children: [
      {
        title: "",
        dataIndex: "acceptance_date",
        key: "acceptance_date",
      },
    ],
  },
  {
    title: "Delay in Acceptance",
    dataIndex: "delay_in_acceptance",
    key: "delay_in_acceptance",
    children: [
      {
        title: "",
        dataIndex: "delay_in_acceptance",
        key: "delay_in_acceptance",
      },
    ],
  },
  {
    title: "Payment Due Date",
    dataIndex: "payment_due_date",
    key: "payment_due_date",
    children: [
      {
        title: "",
        dataIndex: "payment_due_date",
        key: "payment_due_date",
      },
    ],
  },
  {
    title: "Payment Receive Date",
    dataIndex: "payment_received_date",
    key: "payment_received_date",
    children: [
      {
        title: "",
        dataIndex: "payment_received_date",
        key: "payment_received_date",
      },
    ],
  },
  {
    title: "Realise Date",
    dataIndex: "realise_date",
    key: "realise_date",
    children: [
      {
        title: "",
        dataIndex: "realise_date",
        key: "realise_date",
      },
    ],
  },
  {
    title: "CO/BL COST",
    dataIndex: "co_bl_cost",
    key: "co_bl_cost",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "co_bl_cost",
        key: "co_bl_cost",
      },
    ],
  },
  {
    title: "C&F COST PAID (EXPORT)",
    dataIndex: "cnf_cost_paid_export",
    key: "cnf_cost_paid_export",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "cnf_cost_paid_export",
        key: "cnf_cost_paid_export",
      },
    ],
  },
  {
    title: "Potential Opportunity for Savings",
    dataIndex: "potential_opportunity_for_savings",
    key: "potential_opportunity_for_savings",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "potential_opportunity_for_savings",
        key: "potential_opportunity_for_savings",
      },
    ],
  },
  {
    title: "Used Transport",
    dataIndex: "used_transport",
    key: "used_transport",
    children: [
      {
        title: "",
        dataIndex: "used_transport",
        key: "used_transport",
      },
    ],
  },
  {
    title: "CBM Information",
    dataIndex: "cbm_information",
    key: "cbm_information",
    children: [
      {
        title: "",
        dataIndex: "cbm_information",
        key: "cbm_information",
      },
    ],
  },
  {
    title: "Transport Quantity",
    dataIndex: "transport_qty",
    key: "transport_qty",
    children: [
      {
        title: "",
        dataIndex: "transport_qty",
        key: "transport_qty",
      },
    ],
  },
  {
    title: "Optimum Trucking",
    dataIndex: "optimum_trucking",
    key: "optimum_trucking",
    children: [
      {
        title: "",
        dataIndex: "optimum_trucking",
        key: "optimum_trucking",
      },
    ],
  },
  {
    title: "Optimum Cost",
    dataIndex: "optimum_cost",
    key: "optimum_cost",
    children: [
      {
        title: "",
        dataIndex: "optimum_cost",
        key: "optimum_cost",
      },
    ],
  },
  {
    title: "Potential Savings Opportunity",
    dataIndex: "potential_savings_opportunity",
    key: "potential_savings_opportunity",
    children: [
      {
        title: "",
        dataIndex: "potential_savings_opportunity",
        key: "potential_savings_opportunity",
      },
    ],
  },
  {
    title: "Size of Truck",
    dataIndex: "size_of_truck",
    key: "size_of_truck",
    children: [
      {
        title: "",
        dataIndex: "size_of_truck",
        key: "size_of_truck",
      },
    ],
  },
  {
    title: "BGMEA Commission @.37/Dz",
    dataIndex: "bgmea_commission",
    key: "bgmea_commission",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "bgmea_commission",
        key: "bgmea_commission",
      },
    ],
  },
  {
    title: "UD FEE@930",
    dataIndex: "ud_fee",
    key: "ud_fee",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "ud_fee",
        key: "ud_fee",
      },
    ],
  },
  {
    title: "Amendment@600",
    dataIndex: "amendment",
    key: "amendment",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "amendment",
        key: "amendment",
      },
    ],
  },
  {
    title: "UD COST",
    dataIndex: "ud_cost",
    key: "ud_cost",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "ud_cost",
        key: "ud_cost",
      },
    ],
  },
  {
    title: "TRANSPORT COST (IMPORT)",
    dataIndex: "transport_cost_import",
    key: "transport_cost_import",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "transport_cost_import",
        key: "transport_cost_import",
      },
    ],
  },
  {
    title: "TRANSPORT COST (EXPORT)",
    dataIndex: "transport_cost_export",
    key: "transport_cost_export",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "transport_cost_export",
        key: "transport_cost_export",
      },
    ],
  },
  {
    title: "EXP Cost",
    dataIndex: "exp_cost",
    key: "exp_cost",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "exp_cost",
        key: "exp_cost",
      },
    ],
  },
  {
    title: "SOURCE TAX@1%",
    dataIndex: "source_tax",
    key: "source_tax",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "source_tax",
        key: "source_tax",
      },
    ],
  },
  {
    title: "CENTRAL BANK FUND@.03%",
    dataIndex: "central_bank_found",
    key: "central_bank_found",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "central_bank_found",
        key: "central_bank_found",
      },
    ],
  },
];

const PAGE_SIZE = 50;

const ExportAndSummary = () => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);
  const [withoutDate, setWithoutDate] = useState(0);
  // ux2(final-2): the backend now paginates only when per_page is sent (whole-branch review C-1);
  // this page always sends per_page so a widened range shows a real pager instead of a silent 50.
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  // ux2(C1): hand_over_date has no default filter today; open on the last 30 days so the page
  // isn't blank, while the endpoint stays backward compatible when from_date/to_date are absent.
  const getDefaultDateRange = () => [moment().subtract(29, "days"), moment()];
  const [dateRange, setDateRange] = useState(getDefaultDateRange);

  // Guard against setState after unmount and against a slower, stale request clobbering a
  // faster, later one (round-1 pattern).
  const mountedRef = useRef(true);
  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);
  const reqIdRef = useRef(0);

  const fetchExportSummary = useCallback(() => {
    const myReq = ++reqIdRef.current;
    setLoading(true);
    setFetchError(null);
    const [from, to] = dateRange || [];
    // /api/import-expense/import-expense-report
    getData("/api/export-expense/export-expense-report", false, {
      ...(from && to && { from_date: from.format("YYYY-MM-DD"), to_date: to.format("YYYY-MM-DD") }),
      per_page: PAGE_SIZE,
      page,
    })
      .then((data) => {
        if (!mountedRef.current || myReq !== reqIdRef.current) return;
        if (!data || data?.status !== 200) {
          setFetchError("Could not load this list.");
          return;
        }
        setDataSource(data?.data?.data?.data);
        setWithoutDate(data?.data?.data?.meta?.without_date || 0);
        setTotal(data?.data?.data?.total || 0);
      })
      .catch((error) => {
        if (!mountedRef.current || myReq !== reqIdRef.current) return;
        setFetchError(error?.message || "Could not load this list.");
      })
      .finally(() => {
        if (!mountedRef.current || myReq !== reqIdRef.current) return;
        setLoading(false);
      });
  }, [dateRange, page]);

  useEffect(() => {
    fetchExportSummary();
  }, [fetchExportSummary]);

  const handleDateRangeChange = (dates) => {
    setPage(1);
    setDateRange(dates && dates[0] && dates[1] ? dates : getDefaultDateRange());
  };

  return (
    <Card title="Export Expense Summary" style={{ width: "100%" }}>
      <Space style={{ marginBottom: 8 }}>
        <span>Handover Date:</span>
        <DatePicker.RangePicker size="small" value={dateRange} onChange={handleDateRangeChange} allowClear={false} />
        {withoutDate > 0 && <span>({withoutDate} rows have no handover date and are excluded from any range)</span>}
      </Space>
      <ListTable
        dataSource={dataSource}
        columns={columns}
        scroll={{
          x: "max-content",
        }}
        bordered
        pagination={{
          current: page,
          pageSize: PAGE_SIZE,
          total,
          onChange: (nextPage) => setPage(nextPage),
        }}
        loading={loading}
        error={fetchError}
        onRetry={() => fetchExportSummary()}
        size="small"
        locale={{
          emptyText: (
            <Empty
              description={`No records between ${dateRange?.[0]?.format("DD-MMM-YYYY")} and ${dateRange?.[1]?.format(
                "DD-MMM-YYYY",
              )}. Widen the range above.`}
            />
          ),
        }}
        style={{
          margin: "20px 0",
        }}
      />
    </Card>
  );
};

export default ExportAndSummary;
